import { ExtendedPaletteColorName } from '@robinhood/design';
import { LinearGradientColor } from '@robinhood/design/product/themes';

export const GoldGradient: LinearGradientColor = {
  angle: 90,
  colorStops: [
    { color: ExtendedPaletteColorName.BankingAccentLight, stop: 0 },
    { color: ExtendedPaletteColorName.BankingAccentDark, stop: 1 },
  ],
};
